import {
  emitIframeMessage,
  IframeMessage,
} from '@longnecktech/splash-commons-fe';
import { GoalsData } from '@models/goals';
import Phaser from 'phaser';
import { ModalSheet } from './modal-sheet';
import { ModalSheetConfig } from './modal-sheet/modal-sheet.types';

export class GoalsSheet<TemplateData> extends ModalSheet<TemplateData> {
  constructor(
    scene: Phaser.Scene,
    config: ModalSheetConfig<TemplateData> = {},
  ) {
    super(scene, { ...config, iconKey: 'goals' });
  }

  protected createContent(content: Phaser.GameObjects.Container): void {
    const element = this.createDomContent('goals', this.cfg.templateData);
    content.add([element]);

    element.addListener('click');
    element.on('click', (event: MouseEvent) => {
      const btn = (event.target as HTMLElement).closest<HTMLButtonElement>(
        'button.goal-row',
      );
      if (!btn) return;
      const data = this.cfg.templateData as GoalsData;
      const selectedGoalUuid = btn.dataset.uuid;
      const selectedGoal = data.goals.find((g) => g.uuid === selectedGoalUuid);
      if (selectedGoal) {
        emitIframeMessage(IframeMessage.Deposit, {
          gameUuid: data.gameUuid,
          gameType: 'BOARD',
          goal: selectedGoal,
        });
      } else {
        this.hide();
      }
    });
  }
}
